import { render } from "./Layout.vue?vue&type=template&id=3115edd4&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3115edd4"

export default script